import React, { Component } from "react";
import "./AboutMe.css";

const IMAGE_SOURCE_URL = "/img/me.jpg";

class AboutMe extends Component {
  render() {
    return (
      <div id="about-me-container">
        <div id="about-me-content">
          <h2 id="about-me-title">Hi I'm Sharad</h2>
          <div id="about-me-description">
            <p>I like learning.</p>
          </div>
        </div>
        <div id="about-me-photo">
          <img
            alt="Sharad headshot"
            src={IMAGE_SOURCE_URL}
            className="rounded"
          />
        </div>
      </div>
    );
  }
}

export default AboutMe;
